exports = module.exports = require("./../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content-row{padding:2em 4em}.bfm-link{display:inline-block;color:#252525;text-decoration:none;-webkit-transition:all .3s ease-in;transition:all .3s ease-in}.bfm-link:hover{color:#6c6c6c}button[disabled],button[disabled]:active,button[disabled]:hover{background:#ccc;border-color:#ccc;text-shadow:none;cursor:auto}.clearfix:after{content:\" \";display:block;clear:both}@media(max-width:849px){.content-row{padding:2em .5em}}@media(max-width:1000px){.content-row{padding:2em}}@media(max-width:849px){.home-areas.content-row{padding:0}}@media(min-width:850px){.home-areas{width:100%;position:relative;-webkit-flex-flow:row wrap;-ms-flex-flow:row wrap;flex-flow:row wrap;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./app/screens/App/screens/Home/styles/home-areas.css
// module id = 100
// module chunks = 0